import React from 'react';
import { MTooltipPosition } from './MTooltip.model';
import MTooltipView from './MTooltip.view';

type Props = {
  text: string | JSX.Element;
  position?: MTooltipPosition;
  trigger?: ('hover' | 'click' | 'focus' | 'contextMenu')[];
};

const MTooltip: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MTooltipView text={props.text} trigger={props.trigger} position={props.position}>
      {props.children}
    </MTooltipView>
  );
};

MTooltip.displayName = 'MTooltip';
MTooltip.defaultProps = {};

export default MTooltip;
